var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'sticky-graphic',
    ("sticky-graphic-" + _vm.compType),
    { active: _vm.active }
  ]},[_c('WVimeoSource',{ref:"vimeoSource",class:['sticky-graphic__video', ("sticky-graphic-" + _vm.compType + "__video")],attrs:{"title":"","vimeoId":_vm.vimeoUrl.vimeo_data.id,"autoplay":1,"controls":0,"loop":true,"popup":false,"muted":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }